import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ScratchPad } from "@/features/reader/notes/ScratchPad";
import { useEffect, useState } from "react";
import OnboardingGuide from "../reader/ onboarding/OnboardingGuide";
import OnboardingFeedbackHintFlow from "../reader/ onboarding/flows/OnboardingFeedbackHintFlow";
import OnboardingReportsAnnouncementFlow from "../reader/ onboarding/flows/OnboardingReportsAnnouncementFlow";
import OnboardingShareFeedbackHintFlow from "../reader/ onboarding/flows/OnboardingShareFeedbackHintFlow";
import { Feedback } from "./Feedback";
import { GradeEditor } from "./GradeEditor";
import GradingReport from "./GradingReport";
import { GradingPanel } from "./grading-panel/GradingPanel";

interface GradingProps {
  isLoading: boolean;
  isReferencesPanelOpen: boolean;
  feedbackStatus: string | undefined;
  onTabChange: (value: string) => void;
}

export const Grading = ({
  isLoading,
  isReferencesPanelOpen,
  feedbackStatus,
  onTabChange,
}: GradingProps) => {
  const [feedbackUnlocked, setFeedbackUnlocked] = useState(false);

  // Reset unlock state when status changes from published
  useEffect(() => {
    if (feedbackStatus !== "published") {
      setFeedbackUnlocked(false);
    }
  }, [feedbackStatus]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center w-full -mt-16">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`w-full ${isReferencesPanelOpen ? "-ml-[200px]" : ""}`}>
      <Tabs
        defaultValue="criteria"
        className="flex flex-col h-full"
        onValueChange={onTabChange}
      >
        {/* Sticky Tabs Header */}
        <div
          id="hint-feedback"
          className="sticky top-0 bg-background z-10 pt-6 pb-6 shrink-0"
        >
          <div className="max-w-2xl mx-auto">
            <TabsList className="w-full">
              <TabsTrigger value="criteria" className="flex-1">
                Grading
              </TabsTrigger>
              <TabsTrigger value="feedback" className="flex-1">
                Feedback
              </TabsTrigger>
            </TabsList>
          </div>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto pb-40">
          <TabsContent value="criteria" className="h-full">
            <GradingReport />
          </TabsContent>

          <TabsContent value="feedback" className="h-full">
            <Feedback
              feedbackUnlocked={feedbackUnlocked}
              setFeedbackUnlocked={setFeedbackUnlocked}
            />
          </TabsContent>
        </div>
      </Tabs>

      {/* Fixed Footer */}
      <div className="fixed bottom-0 left-0 right-0 z-20 bg-white border-t">
        <GradeEditor feedbackUnlocked={feedbackUnlocked} />
      </div>

      <OnboardingFeedbackHintFlow />
      <OnboardingReportsAnnouncementFlow />
      <OnboardingShareFeedbackHintFlow />
      <OnboardingGuide className="bottom-25" />

      <ScratchPad />
      <GradingPanel />
    </div>
  );
};
